import type { IconProps } from '../types/IconProps.ts';
export const CircleArrowOutUpLeft: IconProps = {
    name: 'CircleArrowOutUpLeft',
    children: [
        `<path d="m3 3 8 8M2 8V2.5c0-.28.22-.5.5-.5H8M2 12A10 10 0 1 0 12 2" />`,
    ]
};